import { render, staticRenderFns } from "./UploadAvatar.vue?vue&type=template&id=0fc0dac9&scoped=true&"
import script from "./UploadAvatar.vue?vue&type=script&lang=js&"
export * from "./UploadAvatar.vue?vue&type=script&lang=js&"
import style0 from "./UploadAvatar.vue?vue&type=style&index=0&id=0fc0dac9&scoped=true&lang=scss&"
import style1 from "./UploadAvatar.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc0dac9",
  null
  
)

export default component.exports